import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Router from 'next/router';
import dynamic from 'next/dynamic';
import styled from 'styled-components';
import ga from 'react-ga';
// import { loadCSS } from 'fg-loadcss';
import moment from 'moment-timezone';
// import { Modal as TmtModal } from 'tmt-ui-kit';
// import cookie from 'cookie';

import config from '~/config';
import Layout from '~/components/Layout';
// import LocalTableFreeSim from '~/components/Toast/LocalTableFreeSim';

import { isDusitApp, isMobile, getCookie } from '~/utils/helpers';
import { getDefaultCurrency } from '~/utils/price';
import { countryMap } from '~/utils/countries';
import dataLayer from '~/utils/data-layer';
import getCurrentCountrySite from '~/utils/region-site-config';
// import GlobalStyle from '~/theme/global-style';
// import ModalTab from '~/components/Modal/ModalTab';

moment.tz.setDefault('Asia/Bangkok');

// const { CountrySelectorModal } = TmtModal;
// const Modal = dynamic(import(/* webpackChunkName: "Modal.Modal.components" */'./Modal/Modal'), { ssr: false, loading: () => null });
// const Forgot = dynamic(import(/* webpackChunkName: "LoginSignup.Forgot.components" */'./LoginSignup/Forgot'), { ssr: false });
// const Loader = dynamic(import(/* webpackChunkName: "Loader.FullLoader.components" */'./Loader/FullLoader'), { ssr: false, loading: () => null });

// const LoginModal = dynamic(() => import(/* webpackChunkName: "LoginSignup.LoginModal.components" */'./LoginSignup/LoginModal'), { loading: () => null });
// const SignupModal = dynamic(() => import(/* webpackChunkName: "LoginSignup.SignupModal.components" */'./LoginSignup/SignupModal'), { loading: () => null });
const LoginSignupModalTab = dynamic(
  () => import(/* webpackChunkName: "LoginSignup.LoginSignupModalTab.components" */'./LoginSignup/LoginSignupModalTab'),
  { loading: () => null }
);
const Forgot = dynamic(() => import(/* webpackChunkName: "LoginSignup.Forgot.components" */'./LoginSignup/ForgotPassword'), { loading: () => null });
const Modal = dynamic(() => import(/* webpackChunkName: "Modal.Modal.components" */'./Modal/Modal'), { loading: () => null });
const Loader = dynamic(() => import(/* webpackChunkName: "Loader.FullLoader.components" */'./Loader/FullLoader'), { loading: () => null });
const TourCategoryModal = dynamic(() => import(/* webpackChunkName: "Popup.TourCategoryModal.components" */'./Popup/TourCategoryModal'), { loading: () => null });
const VideoModal = dynamic(() => import(/* webpackChunkName: "General.VideoModal.components" */'./General/VideoModal'), { loading: () => null });
// const TripPreferenceModal = dynamic(
//   () => import(/* webpackChunkName: "General.TripPreferenceModal.components" */'./General/TripPreferenceModal'),
//   { loading: () => null }
// );

// const DynamicLoadedModal = dynamic({
//   // ssr: false,
//   modules: () => ({
//     // LoginModal: import(/* webpackChunkName: "LoginSignup.LoginModal.components" */'./LoginSignup/LoginModal'),
//     // SignupModal: import(/* webpackChunkName: "LoginSignup.SignupModal.components" */'./LoginSignup/SignupModal'),
//     TourCategoryModal: import(/* webpackChunkName: "Popup.TourCategoryModal.components" */'./Popup/TourCategoryModal'),
//     VideoModal: import(/* webpackChunkName: "General.VideoModal.components" */'./General/VideoModal'),
//     // GdprBanner: import(/* webpackChunkName: "Gdpr.GdprBanner.components" */'./Gdpr/GdprBanner'),
//     // Loader: import(/* webpackChunkName: "Loader.FullLoader.components" */'./Loader/FullLoader'),
//     // Modal: import(/* webpackChunkName: "Modal.`Modal.components" */'./Modal/Modal'),
//     // Forgot: () => import(/* webpackChunkName: "LoginSignup.Forgot.components" */'./LoginSignup/Forgot')
//   }),
//   render: (props, Comp) => {
//     const { loaderProps, forgotModalProps, ...otherProps } = props;
//     return (
//       <Fragment>
//         {/* <Comp.LoginModal {...otherProps} /> */}
//         {/* <Comp.SignupModal {...otherProps} /> */}
//         <Comp.TourCategoryModal />
//         <Comp.VideoModal />
//         {/* {localTableFreeSimProps.isShow && (
//           <Comp.LocalTableFreeSim
//             to={localTableFreeSimProps.link}
//             onClickSim={localTableFreeSimProps.onClick}
//             onClose={localTableFreeSimProps.onClose}
//           />
//         )} */}
//         {/* <Comp.GdprBanner /> */}
//         {/* <Comp.Loader show={loaderProps.show} /> */}
//         {/* {forgotModalProps.isOpen && (
//           <Comp.Modal
//             isOpen={forgotModalProps.isOpen}
//             onClose={forgotModalProps.onClose}
//             id="forgot"
//             zIndex={10000}
//           >
//             <Comp.Forgot />
//           </Comp.Modal>
//         )} */}
//       </Fragment>
//     );
//   },
//   loading: () => null
// });

const PageContainer = styled.div`
  padding-top: '45px';
  transition: padding-top 0.5s ease-in-out;
`;

import { actions as appActions } from '~/redux/reducers/app';
import { actions as popupActions } from '~/redux/reducers/popup';
import { actions as sessionActions } from '~/redux/reducers/session';
import { actions as toastActions } from '~/redux/reducers/toast';
import { actions as infoActions } from '~/redux/reducers/info';
import { actions as galleryActions } from '~/redux/reducers/gallery';
import TGTHPartnerToast from './Affiliate/TGTHPartnerToast';

const enhance = connect(
  state => ({
    first: state.session.first,
    isLoading: state.app.isLoading,
    customTheme: state.app.customTheme,
    isGDPR: state.app.isGDPR,
    // isOpenSubscribe: state.popup.isOpenSubscribe,
    isPageChanged: state.session.isPageChanged,
    isOpenClassifyUser: state.session.isOpenClassifyUser,
    isOpenForgot: state.session.isOpenForgot,
    isLoggedIn: state.session.isLoggedIn,
    isClassifyTriggered: state.session.isClassifyTriggered,
    // isSubscribeTriggered: state.session.isSubscribeTriggered,
    userConfig: state.info.userConfig,
    sessionData: state.session.data,
    // step: state.popup.step,
    session: state.session,
    isOpenLogin: state.session.isOpenLogin,
    isOpenSignup: state.session.isOpenSignup,
    isOpenTourCategory: state.popup.isOpenTourCategory,
    isOpenVideo: state.trip.isOpenVideo,
    partnerConfig: state.app.partnerConfig,
    galleryName: state.gallery.galleryName,
    // isTripPreferenceModalOpened: state.app.isTripPreferenceModalOpened,
  }),
  {
    ...appActions,
    ...popupActions,
    ...sessionActions,
    ...toastActions,
    closeGallery: galleryActions.closeGallery,
    loadCombinedDynamic: infoActions.loadCombinedDynamic,
  }
);

// const loadMessengerPlugin = () => {
//   /* eslint-disable */
//   !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
//   n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
//   n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
//   t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
//   document,'script','https://connect.facebook.net/en_US/fbevents.js');
//   fbq('init', '641034882637977');
//   fbq('track', 'PageView');
//   window.fbAsyncInit = function() {
//     FB.init({
//       appId      : '512381822169849',
//       xfbml      : true,
//       version    : 'v2.5'
//     });
//   };
//   (function(d, s, id){
//     var js, fjs = d.getElementsByTagName(s)[0];
//     if (d.getElementById(id)) {return;}
//     js = d.createElement(s); js.id = id;
//     js.src = "//connect.facebook.net/en_US/sdk/xfbml.customerchat.js";
//     fjs.parentNode.insertBefore(js, fjs);
//   }(document, 'script', 'facebook-jssdk'));
//   /* eslint-enable */
// };

class NewApp extends Component {
  static propTypes = {
    children: PropTypes.any,
    // first: PropTypes.bool,
    isLoading: PropTypes.bool,
    customTheme: PropTypes.object,
    setCustomTheme: PropTypes.func,
    isLoggedIn: PropTypes.bool,
    isOpenForgot: PropTypes.bool,
    isGDPR: PropTypes.bool,
    // isOpenClassifyUser: PropTypes.bool,
    isClassifyTriggered: PropTypes.bool,
    isPageChanged: PropTypes.bool,
    userConfig: PropTypes.object,
    sessionData: PropTypes.object,
    url: PropTypes.object,
    loaded: PropTypes.func,
    loading: PropTypes.func,
    setShowGDPR: PropTypes.func,
    setIsMobile: PropTypes.func,
    getSessionData: PropTypes.func,
    getInitialData: PropTypes.func,
    openClassifyUser: PropTypes.func,
    openLogin: PropTypes.func,
    openSignup: PropTypes.func,
    setSessionData: PropTypes.func,
    openForgot: PropTypes.func,
    setWithPromo: PropTypes.func,
    setPromoInput: PropTypes.func,
    setIsPageChanged: PropTypes.func,
    setTriggerClassify: PropTypes.func,
    loadCombinedDynamic: PropTypes.func,
    logChangePath: PropTypes.func,
    oauthLoginSuccess: PropTypes.func,
    addUtm: PropTypes.func,
    setRedirectCallback: PropTypes.func,
    isOpenLogin: PropTypes.bool,
    isOpenSignup: PropTypes.bool,
    isOpenTourCategory: PropTypes.bool,
    isOpenVideo: PropTypes.bool,
    partnerConfig: PropTypes.object,
    closeGallery: PropTypes.func,
  }

  componentDidMount() {
    window.requestIdleCallback(() => {
      import(/* webpackChunkName: "object-fit-images.module" */'object-fit-images')
        .then(({ default: objectFitImages }) => {
          objectFitImages();
        });
    });
    window.requestAnimationFrame(() => {
      [`${config.assetPath}/static/css/style.min.css`, `${config.assetPath}/static/css/global.min.sbxp6.css`].forEach((cssPath) => {
        const styles = document.createElement('link');
        styles.rel = 'stylesheet';
        styles.type = 'text/css';
        styles.href = cssPath;
        document.getElementsByTagName('head')[0].appendChild(styles);
      });
    });

    // window.requestIdleCallback(() => {
    //   Promise.all([
    //     import(/* webpackChunkName: "object-fit-images.module" */'object-fit-images'),
    //     // import(/* webpackChunkName: "lozad.module" */'lozad'),
    //     import(/* webpackChunkName: "fg-loadcss.module" */'fg-loadcss'),
    //   ])
    //     .then(([
    //       { default: objectFitImages },
    //       // { default: lozad },
    //       { loadCSS },
    //     ]) => {
    //       objectFitImages();
    //       // this.observer = lozad('.lazy');
    //       // this.observer.observe();
    //       loadCSS(`${config.assetPath}/static/css/style.min.css`);
    //       loadCSS(`${config.assetPath}/static/css/global.min.sbxp6.css`);
    //     });
    // });
    window.requestIdleCallback(() => {
      dataLayer().push({
        event: 'PageView',
        path: window.location.pathname
      });
    });
    Router.onRouteChangeStart = () => { // eslint-disable-line
      this.props.loading();
      this.props.setIsPageChanged();
      if (this.props.customTheme) {
        this.props.setCustomTheme(this.props.customTheme.main);
      }
    };
    Router.beforePopState(() => {
      if (this.props.galleryName) {
        this.props.closeGallery();
        return false;
      }
      return true;
    });
    Router.onRouteChangeComplete = () => { // eslint-disable-line
      this.props.loaded();
      this.props.logChangePath(window.location.pathname);
      window.requestIdleCallback(() => {
        ga.pageview(window.location.pathname, ['auTracker']);
        dataLayer().push({
          event: 'PageView',
          path: window.location.pathname
        });
      });
      this.onChangeRoute();
    };
    Router.onRouteChangeError = () => this.props.loaded(); // eslint-disable-line
    // const objectFitImages = require('object-fit-images');
    // objectFitImages();
    // const lozad = require('lozad');
    // this.observer = lozad('.lazy');
    // this.observer.observe();
    // loadCSS(`${config.assetPath}/static/css/style.min.css`);
    // loadCSS(`${config.assetPath}/static/css/global.min.sbxp6.css`);
    window.requestAnimationFrame(() => {
      this.props.getInitialData()
        .then(() => {
          const query = this.props.url.query || {};
          if (query.login_success === 'true') {
            ga.set({ referrer: config.baseURL.en }, ['auTracker']);
          }
        });
      this.props.logChangePath(window.location.pathname);
    });
    // Router.onRouteChangeStart = () => {
    //   this.props.loading();
    //   this.props.setIsPageChanged();
    //   if (this.props.customTheme) {
    //     this.props.setCustomTheme(this.props.customTheme.main);
    //   }
    // };
    // Router.onRouteChangeComplete = () => {
    //   this.props.loaded();
    //   this.props.logChangePath(window.location.pathname);
    //   ga.pageview(window.location.pathname);
    //   this.onChangeRoute();
    // };
    // this.props.logChangePath(window.location.pathname); (Move to above cb)
    // Router.onRouteChangeError = () => this.props.loaded();
    // if (moment().isSameOrBefore(moment('26-11-2017 23:55', 'DD-MM-YYYY HH:mm')) && this.props.url.pathname !== '/trip-detail') {
    window.requestAnimationFrame(() => {
      const closeGdprCookie = getCookie('is_close_gdpr');
      let pushGdpr = true;
      if (!closeGdprCookie) {
        document.cookie = 'is_close_gdpr=false; path=/;expires=Fri, 31 Dec 9999 23:59:59 GMT';
      } else if (closeGdprCookie === 'true') {
        pushGdpr = false;
      }
      if (pushGdpr) {
        setTimeout(() => {
          window.requestAnimationFrame(() => {
            this.props.setShowGDPR(true);
          });
        }, 2000);
      }
    });

    // window.onload = () => {
    //   const closeGdprCookie = getCookie('is_close_gdpr');
    //   let pushGdpr = true;
    //   if (!closeGdprCookie) {
    //     document.cookie = 'is_close_gdpr=false; path=/;expires=Fri, 31 Dec 9999 23:59:59 GMT';
    //   } else if (closeGdprCookie === 'true') {
    //     pushGdpr = false;
    //   }
    //   if (pushGdpr) {
    //     setTimeout(() => this.props.gdprBannerShow(), 2000);
    //   }
    //   // setTimeout(() => this.loadZendeskJS(), 10000);
    //   // setTimeout(loadMessengerPlugin, 10000);
    // };
    setTimeout(() => {
      window.requestIdleCallback(() => {
        dataLayer().push({
          event: 'ActiveCampaign',
        });
      });
    }, 3000);
    this.onChangeRoute();
  }

  onChangeRoute = () => {
    window.requestAnimationFrame(() => {
      const query = this.props.url.query || {};
      const referenceId = getCookie('reference_id');
      this.props.loadCombinedDynamic()
        .then(() => {
          const countrySite = getCurrentCountrySite();
          if ((countrySite !== 'TH' || this.props.sessionData.country !== 'TH' || query.affid || referenceId) && !this.props.sessionData.userType) {
            if (window.hj) {
              window.hj('trigger', 'record');
            }

            let country;
            let currency;

            if (query.affid === 'DUSITAPP' || referenceId === 'DUSITAPP') {
              country = 'DUSIT';
            } else if (countrySite === 'AU') {
              country = countryMap[countrySite];
              currency = getDefaultCurrency(countrySite);
            }
            if (country) {
              this.props.setSessionData({
                userType: { type: country, selected_at: moment().toDate() },
                ...currency ? { currency } : {},
              }, true)
                .then(() => {
                  ga.set({ dimension1: country }, ['auTracker']);
                  ga.event({ category: 'User', action: 'Classify User' }, ['auTracker']);
                });
              this.props.openClassifyUser(false);
            }
          }
          if (window.hj) {
            if (
              this.props.sessionData.userType
              && this.props.sessionData.userType.type
            ) {
              window.hj('tagRecording', [this.props.sessionData.userType.type]);
            } else {
              window.hj('tagRecording', ['not-selected-country']);
            }
          }
          // if ((query.affid === 'accesstrade' || referenceId === 'accesstrade') && !this.props.sessionData.userType) {
          //   this.props.setSessionData({
          //     currency: 'THB',
          //     userType: { type: 'TH', selected_at: moment().toDate() }
          //   }, true)
          //   .then(() => {
          //     ga.set({ dimension1: 'TH' });
          //     ga.event({ category: 'User', action: 'Classify User' });
          //   });
          //   this.props.openClassifyUser(false);
          // }
          ga.set({dimension17: this.props.userConfig.searchFilterEnabled ? 'true' : 'false'}, ['auTracker']);
          // ga.event({ category: 'User', action: 'Classify User' });
        });
      if (!this.props.isPageChanged && isMobile()) {
        this.props.setIsMobile();
      }
      if (getCookie('site_visited')) {
        this.triggerClassifyUser();
        // this.triggerSubscribe();
      }
      // let isShowLocalTableFreeSim = false;
      if (!getCookie('show_localtable_free_sim')) {
        document.cookie = 'show_localtable_free_sim=true; path=/;expires=Fri, 31 Dec 9999 23:59:59 GMT';
        // isShowLocalTableFreeSim = true;
      } else if (getCookie('show_localtable_free_sim') === 'true') {
        // isShowLocalTableFreeSim = true;
      }
      // this.setState({ isShowLocalTableFreeSim }); // eslint-disable-line
      if (!getCookie('site_visited')) {
        document.cookie = 'site_visited=true; path=/;';
      }
      // console.log(query.afffid, referenceId);
      if (query.affid === 'accesstrade' || referenceId === 'accesstrade') {
        // console.log('calling accesstrade tracking code');
        dataLayer().push({
          event: 'trigger_landing_accesstrade',
        });
      }
      this.processQuery();
    });
  }

  // onClickLocalTableFreeSim = () => {
  //   document.cookie = 'show_localtable_free_sim=false; path=/;expires=Fri, 31 Dec 9999 23:59:59 GMT';
  // }

  // onCloseLocalTableFreeSim = () => {
  //   const date = new Date();
  //   date.setDate(date.getDate() + 1);
  //   const expiresDate = date.toUTCString();
  //   document.cookie = `show_localtable_free_sim=false; path=/;expires=${expiresDate}`;
  //   document.body.className = '';
  //   // this.setState({ isShowLocalTableFreeSim: false });
  // }

  processQuery = () => {
    const promises = [];
    const data = {};
    const { url, partnerConfig } = this.props;
    const query = url.query || {};
    const { utm_source, utm_medium, utm_campaign } = query; // eslint-disable-line
    if (utm_source || utm_medium || utm_campaign) { // eslint-disable-line
      this.props.addUtm(query);
    }
    if (query.source) {
      data.source = query.source;
    }
    if (query.promo) {
      data.promo = query.promo;
      promises.push(this.props.setPromoInput(query.promo));
    }
    if (query.rc) {
      data.referral_code = query.rc;
    }
    if (query.withpromo) {
      promises.push(this.props.setWithPromo());
    }
    if (Object.keys(data).length > 0) {
      promises.push(this.props.setSessionData(data));
    }
    Promise.all(promises)
      .then(()=> {
        this.props.getSessionData();
      });
    if (query.signup === 'true') {
      window.requestAnimationFrame(() => {
        this.props.openSignup();
      });
    }
    if (query.login === 'true') {
      this.props.openLogin();
      if (query.redirect) {
        this.props.setRedirectCallback(() => {
          window.location = `${window.location.origin}${query.redirect.startsWith('/') ? query.redirect : `/${query.redirect}`}`;
        });
      }
    }
    if ((query.affid || (partnerConfig && partnerConfig.affid)) && document) {
      const affId = query.affid || partnerConfig.affid;
      const expiryDate = new Date();
      expiryDate.setMonth(expiryDate.getMonth() + 1);
      document.cookie = `reference_id=${affId}; expires=${expiryDate};${config.isDevelopment ? ' ' : ' domain=.takemetour.com;'} path=/;"`;
    }
    ['utm_campaign', 'cust_mobile', 'cust_firstname', 'cust_lastname', 'cust_email', 'cust_country', 'cust_hotel'].forEach(key => {
      if (query[key] && document) {
        document.cookie = `${key}=${query[key]}; path=/;`;
      }
    });
    if (isDusitApp()) {
      const expiryDate = new Date();
      expiryDate.setMonth(expiryDate.getMonth() + 1);
      document.cookie = `reference_id=DUSITAPP; expires=${expiryDate}; path=/;"`;
    }
    if (query.login_success === 'true' && this.props.isLoggedIn) {
      this.props.oauthLoginSuccess();
      if (query.redirect) {
        window.location = query.redirect;
      }
    }
  }

  handleClassifyUser = (country) => {
    if (window.hj && country.value !== 'TH') {
      window.hj('trigger', 'record');
      window.hj('tagRecording', [countryMap[country.value]]);
    }
    this.props.setSessionData({
      userType: {
        type: country.label,
        selected_at: moment().toDate()
      },
      currency: getDefaultCurrency(country.value)
    }, true);
    ga.set({ dimension1: country.label }, ['auTracker']);
    ga.event({ category: 'User', action: 'Classify User' }, ['auTracker']);
    this.props.openClassifyUser(false);

    // this.props.toggleTripPreferenceModal(true);
  }

  handleRemindMeLater = () => {
    this.props.setSessionData({ userType: null }, true);
    ga.set({ dimension1: '' }, ['auTracker']);
    this.props.openClassifyUser(false);
    this.props.logCloseCountrySelector();
  }

  triggerClassifyUser = () => {
    if (this.props.isClassifyTriggered) return;
    this.props.setTriggerClassify();
    setTimeout(()=> {
      if (!this.props.sessionData.userType
        // && !this.props.sessionData.is_booking_opened
        && !isDusitApp()
      ) {
        window.requestAnimationFrame(() => {
          this.props.openClassifyUser();
        });
      }
    }, 15000);
  }

  render() {
    const { url } = this.props;
    const query = url.query || {};
    return (
      <PageContainer isGDPR={this.props.isGDPR} customTheme={this.props.customTheme}>
        <Layout url={url} >
          {this.props.children}
        </Layout>
        {/* {this.props.isOpenClassifyUser && (
          <CountrySelectorModal isOpen centerVertical onChange={this.handleClassifyUser} onClose={this.handleRemindMeLater} />
        )} */}
        {/* <Modal isOpen={this.props.isOpenForgot} onClose={() => this.props.openForgot(false)} id="forgot" zIndex={10000}>
          <Forgot />
        </Modal> */}
        {this.props.isLoading && <Loader show />}
        {(this.props.isOpenLogin || this.props.isOpenSignup) && (
          <LoginSignupModalTab
            discount={query.discount}
            subTitle={query.sub_title}
            omitCode={query.omit_code === 'true'}
          />
        )}
        {/* {false && this.props.isOpenLogin && (
          <Fragment>
            {false && <LoginModal
              promo={query.promo}
              discount={query.discount}
              subTitle={query.sub_title}
              omitCode={query.omit_code === 'true'}
            />}
            <ModalTab
              isOpen={this.props.isOpenLogin}
              menus={[
                {
                  name: 'Sign up',
                  isActive: true,
                  component: <h2>Sign up</h2>
                }, {
                  name: 'Login',
                  isActive: null,
                  component: <h2>Login</h2>
                }, {
                  name: 'test',
                  isActive: null,
                  component: <h2>test</h2>
                }]}
            />
          </Fragment>
        )}
        {false && this.props.isOpenSignup && (
          <SignupModal
            promo={query.promo}
            discount={query.discount}
            subTitle={query.sub_title}
            omitCode={query.omit_code === 'true'}
          />
        )} */}
        {this.props.isOpenForgot && (
          <Modal
            isOpen={this.props.isOpenForgot}
            onClose={() => this.props.openForgot(false)}
            id="forgot"
            zIndex={10000}
          >
            <Forgot />
          </Modal>
        )}
        {this.props.isOpenTourCategory && <TourCategoryModal />}
        {this.props.isOpenVideo && <VideoModal />}
        <TGTHPartnerToast />
        {/* {this.props.isTripPreferenceModalOpened && <TripPreferenceModal />} */}
        {/* <DynamicLoadedModal
          promo={query.promo}
          discount={query.discount}
          subTitle={query.sub_title}
          omitCode={query.omit_code === 'true'}
          // isShowLocalTableFreeSim={this.state.isShowLocalTableFreeSim}
          // localTableFreeSimProps={{
          //   isShow: this.state.isShowLocalTableFreeSim,
          //   link: `${config.baseURL.en}/localtable/trip`,
          //   onClick: this.onClickLocalTableFreeSim,
          //   onClose: this.onCloseLocalTableFreeSim
          // }}
        /> */}
        {/* <GlobalStyle /> */}
      </PageContainer>
    );
  }
}

export default enhance(NewApp);
